import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.windenergybridge.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;

export default function CanonicalURL() {
  const { pathname } = useLocation();
  const canonical =
    pathname.endsWith("/") && pathname !== "/"
      ? pathname.slice(0, -1)
      : pathname;
  const fullUrl = `${SITE_URL}${canonical}`;

  return (
    <Helmet>
      <link rel="canonical" href={fullUrl} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph defaults — pages override via their own Helmet */}
      <meta property="og:site_name" content="WeBridge" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:image:width" content="1600" />
      <meta property="og:image:height" content="1067" />

      {/* Twitter Card defaults */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Helmet>
  );
}
